import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { companyInfo, homeHero } from "../data/siteContent";
import landBanner from "../assets/land.jpg";
import droneBanner from "../assets/6_Drone.jpeg";
import generalBanner from "../assets/11_General_Picture.jpeg";
import geolocationBanner from "../assets/09_Geolocation_Mapping.jpeg";
import bigLogo from "../assets/biglogocopy.png";

const bannerImages = [
  landBanner,
  generalBanner,
  droneBanner,
  geolocationBanner,
];

export default function HomeBanner1() {
  const appContext = useContext(AppContext);
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((prevIndex) => (prevIndex + 1) % bannerImages.length);
    }, 4500);

    return () => clearInterval(interval);
  }, []);

  return (
    <section className="ags-home-banner">
      <div className="container-fluid p-0">
        <div className="row g-0 ags-home-banner-row">
          {/* LEFT SIDE */}
          <div className="col-lg-6">
            <div className="ags-home-banner-content">
              <div className="ags-home-banner-inner">
                <img
                  src={bigLogo}
                  alt={companyInfo.shortName}
                  className="ags-home-banner-logo"
                />

                <p className="ags-home-banner-subtitle">
                  {homeHero.description}
                </p>

                <div className="ags-home-banner-divider" />

                <button
                  className="btn btn-secondary btn-rounded px-4 mt-4 d-inline-flex align-items-center"
                  onClick={() => appContext.navTo({ item: "services" })}
                >
                  <span>Explore Services</span>
                  <span className="ms-2" aria-hidden>
                    →
                  </span>
                </button>
              </div>
            </div>
          </div>

          {/* RIGHT SIDE */}
          <div className="col-lg-6">
            <div className="ags-home-banner-image-wrapper">
              {bannerImages.map((image, index) => (
                <img
                  key={image}
                  src={image}
                  alt={`Banner ${index + 1}`}
                  className={`ags-home-banner-image ags-home-banner-image-slide ${index === activeIndex ? "active" : ""}`}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
